import { render, staticRenderFns } from "./IconWorld.vue?vue&type=template&id=6d5a9d16&"
import script from "./IconWorld.vue?vue&type=script&lang=js&"
export * from "./IconWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports